let emailGuest: string = ''
let nameGuest: string = ''

export const guest = {
  getEmail: () => emailGuest,
  setEmail: (newEmailGuest: string) => (emailGuest = newEmailGuest),
  getName: () => nameGuest,
  setName: (newNameGuest: string) => (nameGuest = newNameGuest),
}



// WEBPACK FOOTER //
// ./src/utils/services/guestUserService.ts